import {Directive, forwardRef} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    selector: '[iziviaEmailValidator]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailValidator), multi: true}
    ]
})
export class EmailValidator implements Validator {
    constructor() {
    }

    public static checkEmailPattern(email: string): boolean {
        const emailPattern = /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i;
        return !!email.match(emailPattern);
    }

    validate(email: AbstractControl): ValidationErrors {
        if (email.value && !EmailValidator.checkEmailPattern(email.value)) {
            return {
                emailPattern: false
            };
        }
        return null;
    }
}
